var map = {
	"./cockpit-color-icon.png": 68257,
	"./goodin-color-icon.png": 13841,
	"./hub-color-icon.png": 5485,
	"./keepup-color-icon.png": 35922,
	"./knowlake-color-icon.png": 71049,
	"./ksm-color-icon.png": 7568,
	"./logicprint5-color-icon.png": 10767,
	"./packos-color-icon.png": 57480,
	"./workboost-color-icon.png": 52311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26164;